<div>
    <!-- Database field -->
    <div>
        <li>
            <div class="form-group app-composite-widget clearfix">
                <label class="control-label app-label col-xs-3"
                    [ngClass]="{'required': baseVariableService.selectedVariable.propertyObj['liveSource']?.required}"
                    title="{{locale['LABEL_VARIABLE_PROPERTIES_'+ 'liveSource'.toUpperCase()] || 'liveSource'}}">
                    {{locale.LABEL_DATABASE_DATABASE}}
                </label>
                <wms-variables-template style="display: inline-block;"
                    (onModelChange)="handleModelChange($event)"
                    [templateType]="'var-prop-' + (baseVariableService.selectedVariable.propertyObj['liveSource']?.widgettype || baseVariableService.selectedVariable.propertyObj['liveSource']?.type || 'string')"
                    propertyName="liveSource"
                    [selectedService]="selectedVarService" 
                    [selectedVariable]="baseVariableService.selectedVariable"></wms-variables-template>
                <i class="wms wms-help" container="body"
                    tooltip="{{(locale['MESSAGE_HELP_VARIABLE'][varManagerService.selectedVariableCategory] && locale['MESSAGE_HELP_VARIABLE'][varManagerService.selectedVariableCategory]['liveSource'.toUpperCase()]) || locale['MESSAGE_HELP_VARIABLE']['liveSource'.toUpperCase()]}}"
                    placement="right"></i>
            </div>
        </li>
    </div>
        <!-- Table field -->
    <div>
        <li>
            <div class="form-group app-composite-widget clearfix">
                <label class="control-label app-label col-xs-3"
                    [ngClass]="{'required': baseVariableService.selectedVariable.propertyObj['type'].required}"
                    title="{{locale['LABEL_VARIABLE_PROPERTIES_'+ 'type'.toUpperCase()] || 'type'}}">
                    {{locale.LABEL_TABLE}}
                </label>
                <wms-variables-template style="display: inline-block;"
                    (onModelChange)="handleModelChange($event)"
                    [templateType]="'var-prop-' + (baseVariableService.selectedVariable.propertyObj['type'].widgettype || baseVariableService.selectedVariable.propertyObj['type'].type || 'string')"
                    propertyName="type"
                    [selectedService]="selectedVarService" 
                    [selectedVariable]="baseVariableService.selectedVariable"></wms-variables-template>
                <i class="wms wms-help" container="body"
                    tooltip="{{(locale['MESSAGE_HELP_VARIABLE'][varManagerService.selectedVariableCategory] && locale['MESSAGE_HELP_VARIABLE'][varManagerService.selectedVariableCategory]['type'.toUpperCase()]) || locale['MESSAGE_HELP_VARIABLE']['type'.toUpperCase()]}}"
                    placement="right"></i>
            </div>
        </li>
    </div>   
        <!-- Operation field -->
    <div>
        <li>
            <div class="form-group app-composite-widget clearfix">
                <label class="control-label app-label col-xs-3"
                    [ngClass]="{'required': baseVariableService.selectedVariable.propertyObj['operation'].required}"
                    title="{{locale['LABEL_VARIABLE_PROPERTIES_'+ 'operation'.toUpperCase()] || 'operation'}}">
                    {{locale.LABEL_PROPERTY_LIVEVARIABLEOPERATION}}
                </label>
                <wms-variables-template style="display: inline-block;"
                    (onModelChange)="handleModelChange($event)"
                    [templateType]="'var-prop-' + (baseVariableService.selectedVariable.propertyObj['operation'].widgettype || baseVariableService.selectedVariable.propertyObj['operation'].type || 'string')"
                    propertyName="operation"
                    [selectedService]="selectedVarService" 
                    [selectedVariable]="baseVariableService.selectedVariable"></wms-variables-template>
                <i class="wms wms-help" container="body"
                    tooltip="{{(locale['MESSAGE_HELP_VARIABLE'][varManagerService.selectedVariableCategory] && locale['MESSAGE_HELP_VARIABLE'][varManagerService.selectedVariableCategory]['operation'.toUpperCase()]) || locale['MESSAGE_HELP_VARIABLE']['operation'.toUpperCase()]}}"
                    placement="right"></i>
            </div>
        </li>
    </div>  
</div>
